import { IIconBase } from '..'

const detailIcon = ({
  color = '#333752',
  height = 14,
  width = 14,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.1665 1.1665H5.24984C2.33317 1.1665 1.1665 2.33317 1.1665 5.24984V8.74984C1.1665 11.6665 2.33317 12.8332 5.24984 12.8332'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.833 5.83301V7.58301'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.8332 5.83317H10.4998C8.74984 5.83317 8.1665 5.24984 8.1665 3.49984V1.1665L12.8332 5.83317Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.68548 10.9617L11.3293 12.6054'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.40694 10.4999C10.0377 9.82849 10.0046 8.7729 9.33322 8.14219C8.66179 7.51148 7.6062 7.54449 6.97549 8.21592C6.34479 8.88734 6.37779 9.94293 7.04922 10.5736C7.72065 11.2043 8.77624 11.1713 9.40694 10.4999Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default detailIcon
